import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@elit-hair/elit-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TbAlertTriangle } from "react-icons/tb";

import { ReportIncidentDialog } from "@/pages/incidents/components/report-incident-dialog";

export function HeaderReportIncident() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    return (
        <>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        size="icon"
                        variant="ghost"
                        className="h-8 w-8 shrink-0 text-amber-600 hover:bg-amber-500/10 hover:text-amber-600 dark:text-amber-400 dark:hover:bg-amber-400/10"
                        onClick={() => setOpen(true)}
                        aria-label={t("report_incident")}
                    >
                        <TbAlertTriangle size={20} />
                    </Button>
                </TooltipTrigger>
                <TooltipContent side="bottom" sideOffset={5}>
                    {t("report_incident")}
                </TooltipContent>
            </Tooltip>

            <ReportIncidentDialog open={open} onOpenChange={setOpen} />
        </>
    );
}
